import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import OutsideClickHandler from 'react-outside-click-handler';

import GetCards from "../../components/GetCards/GetCards";
import ToggleView from "../../components/ToggleView/ToggleView";
import Search from "../../components/Search/Search";
import Grid from "../../components/Grid/Grid";
import { Container } from "../../components/Container/Container";
import { DispatchMessage } from "../../components/DispatchMessage/dispatchMessage";

import { addToFavorites, deleteFromFavorites, requestFromManager, requestFromManagerbyContent } from "../../store/favorites/actions";
import { getCustomerInfo } from "../../store/customer/actions";

import { H3, Small, Medium } from "../../styles/typography/typography"
import Svg from "../../../src/assets/icons/icons.js"
import { colors as c } from "../../styles/variables.js"

import {
    ContainerCollectionSt,
    HeaderSt,
    LinkSt,
    LinkMockSt,
    TitleBlockSt,
    SettingsMenuSt,
    SettingsMenuWrapperSt,
    SettingsToggleSt,
    SettingsLeftSt,
    SettingsRigthSt,
    ItemSettingsSt,
    SpanSt,
    ContainerBlockSt,
    RecommendContainerSt,
    RecommendBlockSt,
    RecommendHeaderSt,
    RecommendAddBlockSt,
    SmallSt,
    HeaderTopSt,
    WrapItemSt,
    SecondLevelItemSt,
    SecondLevelSt
} from "./style";

import i18n from "i18next";

const Favorites = () => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [dashboard, setDashboard] = useState(true);
    const [recommendIsOpen, setRecommendIsOpen] = useState(false);
    const [chooseCard, setChooseCard] = useState(false);
    const [allchooseCard, setAllchooseCard] = useState([]);
    const [allchooseCardCollections, setAllchooseCardCollections] = useState([]);
    const [allchooseCardEvents] = useState([]);
    const [cards, setCards] = useState([]);
    const [menuWithRequestIsOpen, setMenuWithRequestIsOpen] = useState(false);
    //попап после отправки на сервер
    const [dispatchMessageControl, setDispatchMessageControl] = useState(false);
    const [requestFromManagerShown, setRequestFromManagerShown] = useState(false);
    const [popupAddFavorites, setPopupAddFavorites] = useState(false);

    const dispatch = useDispatch();
    const messageallProjectsAdded = useSelector((store) => store.favorites.messageallProjectsAdded);
    const favoritesMessage = useSelector((store) => store.favorites.message);
    const favoritesProject = useSelector((store) => store.favorites.project);
    const selection_id = useSelector((store) => store.customer.customer.selection_id);
    const collection = useSelector((store) => store.favorites.collection);
    const event = useSelector((store) => store.favorites.event);
    const project = useSelector((store) => store.favorites.project);
    const count = useSelector((store) => store.favorites.count);
    const token = useSelector((store) => store.auth.dataToken.token);
    const manager_email = useSelector((store) => store.customer.customer.managers && (store.customer.customer.managers[0] && store.customer.customer.managers[0].email));

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    const dispatchMessageControlRef = useRef(dispatchMessageControl);
    dispatchMessageControlRef.current = dispatchMessageControl;

    const _handleOpenMenuClick = () => {
        setMenuIsOpen((prev) => !prev);
    };

    const _handleCloseMenuClick = () => {
        setMenuIsOpen(false);
    };

    const _handleOpenMenuWithRequestClick = () => {
        setRequestFromManagerShown(false);
        setMenuWithRequestIsOpen((prev) => !prev);
    };

    const _onToggleViewClick = (x) => {
        setDashboard(x);
        if (x !== dashboard) {
            setChooseCard(false);
        }
    };

    const _handleOpenRecommendBlockClick = () => {
        setRecommendIsOpen((prev) => !prev);
    };

    const _chooseCard = () => {
        setChooseCard((prev) => !prev);
    };

    // запрос у менеджера
    const _requestManager = () => {
        if (allchooseCard.length > 0) {
            dispatch(requestFromManager(allchooseCard, token));
            setChooseCard(true);
            setAllchooseCard([]);
            setAllchooseCardCollections([]);

            timers.current.push(setTimeout(() => {
                setMenuWithRequestIsOpen(false);
            }, 1500));

            timers.current.push(setTimeout(() => {
                setChooseCard(false);
            }, 1));
        }
    };

    //запрос на контент
    const _handleContentRequestClick = () => {
        if (allchooseCard.length > 0) {
            dispatch(requestFromManagerbyContent(allchooseCard, token));
            setChooseCard(true);
            setAllchooseCard([]);
            setDispatchMessageControl(true);

            timers.current.push(setTimeout(() => {
                setMenuWithRequestIsOpen(false);
            }, 1500));

            timers.current.push(setTimeout(() => {
                setChooseCard(false);
            }, 1));
        }
    };

    //добавить все выбранные карты в allchooseCard
    const _getallchooseCard = useCallback((allCards, status, type) => {
        const setter = type === "catalog"
            ? setAllchooseCard
            : type === "collections"
                ? setAllchooseCardCollections
                : null;

        if (!setter) return;

        if (status === "add" || status === "addAll") {
            setter((prev) => prev.includes(allCards) ? prev : [...prev, allCards]);
        }
        else if (status === "remove") {
            setter((prev) => prev.filter((item) => item !== allCards));
        }
        else if (status === "removeAll") {
            setter([]);
        }
    }, []);

    //Отправка прочеканных карт на сервер в избранное
    const _sendChooseCard = () => {
        if (allchooseCard.length > 0) {
            dispatch(deleteFromFavorites(allchooseCard, "catalog", token));
            setAllchooseCard([]);
        }
        if (allchooseCardCollections.length > 0) {
            dispatch(deleteFromFavorites(allchooseCardCollections, "collections", token));
            setAllchooseCardCollections([]);
        }
        setChooseCard(false);
    };

    // добавить подборку в избранное
    const _addSelectionToFavorites = () => {
        dispatch(addToFavorites(cards, "catalog", token));
        setChooseCard(false);
        setAllchooseCard([]);
        setDispatchMessageControl(true);
    };

    // получение title и id карт из коллеций
    const _getCards = useCallback((newCards) => {
        setCards((prev) => [...prev, ...newCards.map((item) => item.id)]);
    }, []);

    // componentDidMount
    useEffect(() => {
        dispatch(getCustomerInfo(token));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // componentDidUpdate: попап после отправки в избранное
    const isFirstFavorites = useRef(true);
    useEffect(() => {
        if (isFirstFavorites.current) {
            isFirstFavorites.current = false;
            return;
        }

        if (dispatchMessageControlRef.current) {
            setPopupAddFavorites(true);
            timers.current.push(setTimeout(() => {
                setPopupAddFavorites(false);
            }, 1500));
        }
        setDispatchMessageControl(false);
    }, [favoritesProject.length, messageallProjectsAdded]);

    // componentDidUpdate: попап после запроса у менеджера
    const isFirstMessage = useRef(true);
    useEffect(() => {
        if (isFirstMessage.current) {
            isFirstMessage.current = false;
            return;
        }

        setRequestFromManagerShown(true);
        timers.current.push(setTimeout(() => {
            setRequestFromManagerShown(false);
        }, 1500));
        setDispatchMessageControl(false);
    }, [favoritesMessage]);

    // componentDidUpdate: если ничего не выбрано — закрываем меню запроса
    useEffect(() => {
        if (allchooseCard.length === 0 && allchooseCardCollections.length === 0 && allchooseCardEvents.length === 0 && menuWithRequestIsOpen) {
            setMenuWithRequestIsOpen(false);
        }
    }, [allchooseCard.length, allchooseCardCollections.length, allchooseCardEvents.length, menuWithRequestIsOpen]);

    const chooseCardsCheck = (allchooseCard.length > 0 || allchooseCardCollections.length > 0 || allchooseCardEvents.length > 0);

    return (
        <>
            <ContainerCollectionSt>
                {/* блок рекомендации менеджера  */}
                {selection_id && <Container>
                    <RecommendBlockSt className={recommendIsOpen ? "opened" : ""} >
                        <RecommendContainerSt>
                            <RecommendHeaderSt className="RecommendHeaderStyled">
                                <div onClick={_handleOpenRecommendBlockClick} className="reccommendTitle">
                                    <Medium
                                        extra_bold={(window.innerWidth < 768) ? "" : "extra_bold"}
                                        bold={(window.innerWidth < 768) ? "bold" : ""}
                                        uppercase> {i18n.t(`favorites.managers_recommendation`)}
                                    </Medium>
                                    <Svg
                                        className={recommendIsOpen ? "keyboard_arrow_top" : ""}
                                        type="keyboard_arrow" />
                                </div>
                                <RecommendAddBlockSt onClick={() => _addSelectionToFavorites()}>
                                    <Svg type="add" color={c.blue_active} />
                                    <SmallSt uppercase color={c.blue_active}> {i18n.t(`favorites.add_a_selection_to_favorites`)}</SmallSt>
                                    {(popupAddFavorites && window.innerWidth > 767) && <DispatchMessage message={messageallProjectsAdded ? i18n.t(`favorites.all_projects_have_added`) : i18n.t(`favorites.added_to_favorites`)} />}
                                </RecommendAddBlockSt>
                                {(popupAddFavorites && window.innerWidth < 768) && <DispatchMessage message={messageallProjectsAdded ? i18n.t(`favorites.all_projects_have_added`) : i18n.t(`favorites.added_to_favorites`)} />}
                            </RecommendHeaderSt>
                            <ContainerBlockSt recommendIsOpen={recommendIsOpen}>
                                <Container className="recommendCards">
                                    <GetCards
                                        getChannelContent={true}
                                        getSelections={true}
                                        sourceCards={`selections/${selection_id}`}
                                        type="catalog"
                                        title={""}
                                        description={""}
                                        cardDisplayType="carousel"
                                        tile={dashboard}
                                        _getCards={_getCards}
                                    />
                                </Container>
                            </ContainerBlockSt>
                        </RecommendContainerSt>
                    </RecommendBlockSt>
                </Container>}

                {/* конец блока рекомендации менеджера  */}
                <Container padding="true">
                    <HeaderSt>
                        <HeaderTopSt>
                            <TitleBlockSt>
                                <H3>{i18n.t(`favorites.favorites`)}</H3>
                                <LinkMockSt><Small uppercase color={c.blue}>{count}</Small></LinkMockSt>
                            </TitleBlockSt>
                            {(window.innerWidth < 768)
                                ? ""
                                : <>
                                    <div style={{ display: 'none' }}>
                                        <Search
                                            iconSearch="search"
                                            placeholder={i18n.t(`favorites.add_by_name`)}
                                            searchBoxIsOpen={true}
                                        />
                                    </div>
                                    <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={(x) => _onToggleViewClick(x)} />
                                </>
                            }
                        </HeaderTopSt>
                        <OutsideClickHandler onOutsideClick={_handleCloseMenuClick}>
                            <SettingsMenuSt>
                                {(window.innerWidth < 768)
                                    ?
                                    <>

                                        <SettingsToggleSt onClick={() => _requestManager()}>
                                            <Svg type="mail_outline" color={chooseCardsCheck ? c.blue_active : c.grey_passive} />

                                            {menuIsOpen
                                                ?
                                                <div onClick={_handleOpenMenuClick}
                                                    className="toggle" aria-label={i18n.t(`favorites.open_the_menu`)} type="button">
                                                    <span className="visually-hidden">{i18n.t(`favorites.open_the_menu`)}</span>
                                                    <Svg type="close" />
                                                </div>
                                                :
                                                <div onClick={_handleOpenMenuClick}
                                                    className="toggle" aria-label={i18n.t(`favorites.open_the_menu`)} type="button">
                                                    <span className="visually-hidden">{i18n.t(`favorites.open_the_menu`)}</span>
                                                    <Svg type="settings" />
                                                </div>
                                            }

                                        </SettingsToggleSt>
                                        {(requestFromManagerShown && !menuIsOpen) && <DispatchMessage message={favoritesMessage[1].added.length > 0 ? i18n.t(`favorites.request_has_been_sent`) : i18n.t(`favorites.request_already_exists`)} />}
                                    </>
                                    : ""
                                }

                                {/* выделить все, запрос у менеджера, удалить */}
                                <SettingsMenuWrapperSt className={menuIsOpen && window.innerWidth < 768 ? "opened" : ""}>
                                    <SettingsLeftSt>
                                        <form>
                                            <input type="checkbox" checked={chooseCard} onChange={() => _chooseCard()} /> {i18n.t(`favorites.select_all`)}
                                        </form>
                                    </SettingsLeftSt>
                                    <SettingsRigthSt>
                                        {(window.innerWidth < 768)
                                            ?
                                            <>
                                                {manager_email &&
                                                    <ItemSettingsSt className={chooseCard ? "active" : ""} onClick={() => _requestManager()}>
                                                        <Svg
                                                            type="mail_outline"
                                                            color={chooseCardsCheck ? c.blue_active : c.grey_passive} />
                                                        <SpanSt color={chooseCardsCheck ? c.blue_active : c.grey_passive}>{i18n.t(`collections.request_content`)}</SpanSt>

                                                    </ItemSettingsSt>}
                                                {/* запрос на доп.материалы */}
                                                {manager_email &&
                                                    <ItemSettingsSt onClick={() => _requestManager()}>
                                                        <Svg
                                                            type="add"
                                                            color={chooseCardsCheck ? c.blue_active : c.grey_passive} />
                                                        <SpanSt color={chooseCardsCheck ? c.blue_active : c.grey_passive}>{i18n.t(`profile.add_promo_materials`)}</SpanSt>
                                                    </ItemSettingsSt>}
                                                {requestFromManagerShown && <DispatchMessage message={favoritesMessage[1].added && (favoritesMessage[1].added.length > 0 ? i18n.t(`favorites.request_has_been_sent`) : i18n.t(`favorites.request_already_exists`))} />}
                                            </>

                                            :

                                            manager_email &&
                                            <ItemSettingsSt>
                                                {/* открыть/закрыть меню запрос менеджеру */}
                                                <WrapItemSt className="WrapItemStyled" onClick={chooseCardsCheck ? _handleOpenMenuWithRequestClick : null}>
                                                    <SpanSt color={chooseCardsCheck ? c.black : c.grey_passive}>{i18n.t(`collections.request_from_the_manager`)}</SpanSt>
                                                    <Svg className={menuWithRequestIsOpen ? "keyboard_arrow_top" : ""} type="keyboard_arrow"
                                                        color={chooseCardsCheck ? c.black : c.grey_passive} />
                                                </WrapItemSt>

                                                {(menuWithRequestIsOpen)
                                                    && (
                                                        <SecondLevelSt>
                                                            {manager_email &&
                                                                <SecondLevelItemSt onClick={() => _handleContentRequestClick()}>
                                                                    <Svg type="mail_outline" color={c.blue_active} />
                                                                    <LinkSt >
                                                                        <Small color={c.blue_active}>{i18n.t(`collections.content`)}</Small>
                                                                    </LinkSt>
                                                                </SecondLevelItemSt>
                                                            }
                                                            {manager_email &&
                                                                <SecondLevelItemSt onClick={() => _requestManager()}>
                                                                    <Svg type="add" color={c.blue_active} />
                                                                    <LinkSt >
                                                                        <Small color={c.blue_active}>{i18n.t(`profile.add_promo_materials`)}</Small>
                                                                    </LinkSt>
                                                                </SecondLevelItemSt>
                                                            }
                                                            {/* popup с инфой */}
                                                            {requestFromManagerShown &&
                                                                <DispatchMessage message={favoritesMessage[1].added && (favoritesMessage[1].added.length > 0 ? i18n.t(`favorites.request_has_been_sent`) : i18n.t(`favorites.request_already_exists`))} />
                                                            }
                                                        </SecondLevelSt>
                                                    )
                                                }
                                            </ItemSettingsSt>

                                        }
                                        <ItemSettingsSt onClick={() => _sendChooseCard()}>
                                            <Svg type="delete_outline"
                                                color={chooseCardsCheck ? c.black : c.grey_passive} />
                                            <SpanSt color={chooseCardsCheck ? c.black : c.grey_passive}>{i18n.t(`favorites.delete`)}</SpanSt>
                                        </ItemSettingsSt>
                                    </SettingsRigthSt>
                                    {(window.innerWidth < 768)
                                        ?
                                        <>
                                            <div style={{ display: 'none' }}>
                                                <Search
                                                    iconSearch="search"
                                                    placeholder={i18n.t(`favorites.add_by_name`)}
                                                    searchBoxIsOpen={true}
                                                />
                                            </div>
                                        </>
                                        : ""
                                    }
                                </SettingsMenuWrapperSt>

                            </SettingsMenuSt>
                        </OutsideClickHandler>
                    </HeaderSt>
                    {project && <Grid
                        type="catalog"
                        title={""}
                        description={""}
                        cards={project}
                        cardsLength={project.length}
                        tile={dashboard}
                        chooseCard={chooseCard}
                        page={"favorites"}
                        _getallchooseCard={_getallchooseCard}
                    />}
                    {event && (event.length > 0 && <Grid
                        type="events"
                        title={i18n.t(`header.menuList.1.title`)}
                        cards={event}
                        cardsLength={event.length}
                        tile={dashboard}
                        chooseCard={chooseCard}
                        page={"favorites"}
                        _getallchooseCard={_getallchooseCard}
                    />)}
                    {collection && (collection.length > 0 && <Grid
                        type="collections"
                        title={i18n.t(`home.collections`)}
                        cards={collection}
                        cardsLength={collection.length}
                        tile={dashboard}
                        chooseCard={chooseCard}
                        page={"favorites"}
                        _getallchooseCard={_getallchooseCard}
                    />)}
                </Container>
            </ContainerCollectionSt>
        </>
    );
};

export default Favorites;
